<template>
    <li v-if="showItem(item)" v-on:click.stop="itemMethod(item)" :class="item.class">{{ getTitle(item) }}
      <ul class="sub-menu" v-if="hasChildren" v-bind:style="style">
          <li v-for="(child, index) in children" v-on:click.stop="itemMethod(child)" v-bind:key="index" :class="child.class">{{ child.title }}</li>
      </ul>
    </li>
</template>

<script>
export default {
  name: 'ContextMenuItem',
  props: {
    /**
     * Context menu item
     * @type {ContextMenuItem}
     */
    item: Object,
    data: Object,
    titleParameter: Number
  },
  data: function () {
    return {
      toppos: 0,
      usestyle: false,
      toleft: false
    };
  },
  methods: {
    itemMethod: function (item) {
      this.$emit('context-item-clicked', item, this.data);
    },
    getTitle: function (item) {
      if (typeof item.title === 'function') {
        return item.title(this.titleParameter);
      } else return item.title;
    },
    onMouseOver: function (elem) {
    },
    showItem (item) {
      let val = true;
      if (item && item.showItemFunc) {
        val = item.showItemFunc(this.getRowData());
        this.$log('getting called showItemFunc', val, item);
      }
      if (item === this.item) {
        // evaluate root context menu item
        this.$log('evaluating root show', this.children.length > 0);
        // check if original has no method and has children
        // hide if no children and no method itself
        if (this.hasChildren && !item.method) {
          // check if has children after evaluation of
          val = this.children.length > 0;
        }
      }
      return val;
    },
    getRowData() {
      if (this.data && this.data.data && this.data.data.obj) {
        return this.data.data.obj;
      }
    }
  },
  computed: {
    hasChildren () {
      return (this.item.children != null && this.item.children.length > 0);
    },
    children () {
      let res = [];
      if (this.item.children && this.item.children.length > 0) {
        for (let child of this.item.children) {
          if (this.showItem(child)) {
            res.push(child);
          }
        }
      }
      return res;
    },
    style () {
      let left = '248px';
      if (this.toleft) {
        left = '-' + left;
      }
      if (!this.usestyle) {
        return {
          top: 0,
          left: left
        };
      }
      return {
        bottom: this.toppos,
        left: left
      };
    }
  },
  watch: {
    data () {
      var rect = this.$el.getBoundingClientRect();
      let totalheight = $(this.$el).children('.sub-menu').height();
      this.usestyle = (rect.top + totalheight) > window.innerHeight;
      this.toppos = -(this.data.bottom - rect.bottom) + 'px';
      this.toleft = window.innerWidth < (rect.right + 248);
    },
    showItem () {
      console.log('showItem', this.showItem, this);
    }
  }
};
</script>
<style lang="scss" scoped>
$blue600: #1e88e5;
$gray74: #bdbdbd;
$gray93: #ededed;
$gray98: #fafafa;
$delete: #dc3545;
  li {
    &:hover ul {
      display: block;
      position: absolute;
      background: $gray98;
      border: 1px solid $gray74;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    }
    ul {
      display:none;
    }
  }
</style>
